// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Facebook = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                d="M17.8571429,0 L2.14285714,0 C0.95938955,0 0,0.95938955 0,2.14285714 L0,17.8571429 C0,19.0406104 0.95938955,20 2.14285714,20 L8.27008929,20 L8.27008929,13.2004465 L5.45758929,13.2004465 L5.45758929,10 L8.27008929,10 L8.27008929,7.56071431 C8.27008929,4.78616033 9.921875,3.25357165 12.451785,3.25357165 C13.6633927,3.25357165 14.9303559,3.46964291 14.9303559,3.46964291 L14.9303559,6.1928572 L13.5343742,6.1928572 C12.1589279,6.1928572 11.7299107,7.04642841 11.7299107,7.92187486 L11.7299107,10 L14.8004464,10 L14.3093749,13.2004465 L11.7299107,13.2004465 L11.7299107,20 L17.8571429,20 C19.0406104,20 20,19.0406104 20,17.8571429 L20,2.14285714 C20,0.95938955 19.0406104,0 17.8571429,0 Z"
            />
        </svg>
    );
};

export default React.memo(Facebook);
